<template>
  <form @submit.prevent="submitAction" class="grid gap-4">
    <ValidationProvider rules="required" name="content" tag="div" vid="content">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel>Content</BaseFormLabel>
          <BaseFormTextarea v-model="data.content" rows="20" :disabled="active" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="grid grid-flow-col gap-2 justify-start">
      <BaseButton primary :disabled="active">
        <Loader v-if="active" small inverse />
        <template v-else> Create </template>
      </BaseButton>
    </div>
  </form>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
    onData: {
      type: Function,
      default: (data) => data,
    },
    onNoteAssetCreated: {
      type: Function,
      default: null,
    },
    onActive: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      active: false,
      data: {
        content: '',
      },
    };
  },

  methods: {
    setActive(active) {
      this.active = active;
      if (typeof this.onActive === 'function') {
        this.onActive(active);
      }
    },
    resetForm() {
      this.data.content = '';
    },
    async submitAction() {
      try {
        this.setActive(true);

        const { projectAssetId } = await this.$store.dispatch({
          type: 'ui/projectProjectAssets/storeNote',
          projectId: this.projectId,
          formData: this.onData(this.data),
        });

        if (typeof this.onNoteAssetCreated === 'function') {
          this.onNoteAssetCreated(projectAssetId);
        }

        this.$emit('note-created');

        this.resetForm();
      } catch (error) {
        // handle error
      } finally {
        this.setActive(false);
      }
    },
  },
};
</script>
